import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

export default function TentangKami() {
  const values = [
    {
      icon: 'ri-shield-star-line',
      title: 'Kualitas Terjamin',
      description: 'Kami menggunakan mesin laundry modern dan deterjen berkualitas premium untuk hasil terbaik'
    },
    {
      icon: 'ri-customer-service-2-line',
      title: 'Pelayanan Ramah',
      description: 'Tim kami siap melayani dengan sepenuh hati dan memberikan solusi terbaik untuk kebutuhan Anda'
    },
    {
      icon: 'ri-timer-flash-line',
      title: 'Cepat & Tepat Waktu',
      description: 'Komitmen kami untuk mengembalikan cucian sesuai jadwal yang telah disepakati'
    },
    {
      icon: 'ri-hand-heart-line',
      title: 'Kepuasan Pelanggan',
      description: 'Kepuasan Anda adalah prioritas utama kami dalam setiap layanan yang diberikan'
    }
  ];

  const owner = {
    name: 'Retno Dwi Lestari',
    role: 'Founder & Owner',
    image: 'https://public.readdy.ai/ai/img_res/4fe2143a284b21b5438e6d238bdf74b2.jpg',
    description: 'Pendiri dan pengelola YEZ Laundry yang berdedikasi memberikan layanan laundry terbaik dengan sentuhan personal dan profesional'
  };

  const milestones = [
    { year: '2023', event: 'YEZ Laundry didirikan dengan 1 outlet pertama' },
    { year: '2024', event: 'Mencapai 100+ pelanggan setia' },
    { year: '2024', event: 'Menambah layanan express dan antar jemput' },
    { year: '2025', event: 'Melayani 500+ pelanggan per bulan' },
    { year: '2025', event: 'Ekspansi dengan mesin laundry terbaru' },
    { year: '2026', event: 'Menjadi pilihan utama laundry di Klaten' }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero Section */}
      <section className="relative pt-32 pb-20 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-blue-600 to-cyan-600"></div>
        <div className="absolute inset-0 opacity-10">
          <img 
            src="https://readdy.ai/api/search-image?query=modern%20clean%20professional%20laundry%20service%20interior%20with%20rows%20of%20washing%20machines%20bright%20organized%20space%20fresh%20white%20blue%20color%20scheme%20emphasizing%20cleanliness%20efficiency%20professional%20atmosphere&width=1920&height=800&seq=aboutherobg&orientation=landscape" 
            alt="About Background"
            className="w-full h-full object-cover object-top"
          />
        </div>
        
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="text-center">
            <h1 className="text-4xl md:text-5xl font-bold text-white mb-6">Tentang YEZ Laundry</h1>
            <p className="text-lg text-white/95 max-w-3xl mx-auto leading-relaxed">
              Solusi laundry profesional yang mengutamakan kebersihan, ketelitian, dan kepuasan pelanggan sejak 2023
            </p>
          </div>
        </div>
      </section>

      {/* Story Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">Cerita Kami</h2>
              <div className="space-y-4 text-gray-600 leading-relaxed">
                <p>
                  <strong className="text-gray-900">YEZ Laundry</strong> didirikan pada tahun 2023 dengan visi sederhana: memberikan layanan laundry berkualitas tinggi yang terjangkau untuk semua kalangan. Berawal dari sebuah outlet kecil, kami terus berkembang berkat kepercayaan pelanggan setia kami.
                </p>
                <p>
                  Kami memahami bahwa pakaian bersih dan wangi adalah kebutuhan sehari-hari yang penting. Oleh karena itu, kami berkomitmen untuk memberikan layanan terbaik dengan menggunakan teknologi modern dan deterjen berkualitas premium yang aman untuk semua jenis kain.
                </p>
                <p>
                  Tim profesional kami terlatih untuk menangani berbagai jenis pakaian dengan hati-hati, mulai dari pakaian sehari-hari hingga pakaian premium yang memerlukan perawatan khusus. Kepuasan pelanggan adalah prioritas utama kami, dan kami bangga telah melayani ribuan pelanggan dengan hasil yang memuaskan.
                </p>
                <p>
                  Dengan pengalaman lebih dari 1 tahun, YEZ Laundry telah menjadi pilihan utama masyarakat untuk kebutuhan laundry mereka. Kami terus berinovasi dan meningkatkan layanan kami untuk memberikan pengalaman terbaik bagi setiap pelanggan.
                </p>
              </div>
            </div>

            <div className="relative">
              <div className="rounded-2xl overflow-hidden shadow-2xl">
                <img 
                  src="https://readdy.ai/api/search-image?query=modern%20clean%20professional%20laundry%20service%20interior%20showing%20organized%20washing%20machines%20folding%20stations%20with%20neatly%20stacked%20fresh%20white%20towels%20bright%20spacious%20blue%20white%20color%20scheme%20emphasizing%20cleanliness%20professionalism%20quality%20service&width=800&height=900&seq=aboutstory&orientation=portrait" 
                  alt="YEZ Laundry Interior"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="absolute -bottom-6 -right-6 bg-blue-600 text-white p-8 rounded-2xl shadow-xl max-w-xs">
                <div className="text-4xl font-bold mb-2">1+</div>
                <div className="text-sm">Tahun Pengalaman Melayani Pelanggan</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="py-20 bg-gradient-to-b from-blue-50/30 to-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">Nilai-Nilai Kami</h2>
            <p className="text-base text-gray-600 max-w-2xl mx-auto">
              Prinsip yang menjadi fondasi dalam setiap layanan yang kami berikan
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {values.map((value, index) => (
              <div
                key={index}
                className="bg-white rounded-2xl p-8 shadow-md border border-gray-100 text-center hover:shadow-xl transition-all"
              >
                <div className="w-16 h-16 flex items-center justify-center bg-blue-100 rounded-2xl mx-auto mb-5">
                  <i className={`${value.icon} text-3xl text-blue-600`}></i>
                </div>
                <h3 className="text-lg font-semibold text-gray-900 mb-3">{value.title}</h3>
                <p className="text-sm text-gray-600 leading-relaxed">{value.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Timeline Section */}
      <section className="py-20 bg-white">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">Perjalanan Kami</h2>
            <p className="text-base text-gray-600 max-w-2xl mx-auto">
              Melihat perkembangan YEZ Laundry dari waktu ke waktu
            </p>
          </div>

          <div className="relative">
            <div className="absolute left-1/2 transform -translate-x-1/2 h-full w-0.5 bg-blue-200"></div>
            
            <div className="space-y-12">
              {milestones.map((milestone, index) => (
                <div
                  key={index}
                  className={`relative flex items-center ${
                    index % 2 === 0 ? 'justify-start' : 'justify-end'
                  }`}
                >
                  <div className={`w-full lg:w-5/12 ${index % 2 === 0 ? 'lg:pr-12' : 'lg:pl-12'}`}>
                    <div className="bg-white rounded-xl p-6 shadow-md border border-gray-100">
                      <div className="text-2xl font-bold text-blue-600 mb-2">{milestone.year}</div>
                      <p className="text-sm text-gray-700">{milestone.event}</p>
                    </div>
                  </div>
                  
                  <div className="absolute left-1/2 transform -translate-x-1/2 w-4 h-4 bg-blue-600 rounded-full border-4 border-white shadow-md"></div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Owner Section */}
      <section className="py-20 bg-gradient-to-b from-blue-50/30 to-white">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">Pemilik & Pengelola</h2>
            <p className="text-base text-gray-600 max-w-2xl mx-auto">
              Orang di balik kesuksesan dan dedikasi YEZ Laundry
            </p>
          </div>

          <div className="max-w-2xl mx-auto">
            <div className="bg-white rounded-2xl overflow-hidden shadow-xl border border-gray-100">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-0">
                <div className="aspect-[3/4] overflow-hidden">
                  <img 
                    src={owner.image} 
                    alt={owner.name}
                    className="w-full h-full object-cover object-top hover:scale-105 transition-transform duration-300"
                  />
                </div>
                <div className="p-8 flex flex-col justify-center">
                  <h3 className="text-2xl font-bold text-gray-900 mb-2">{owner.name}</h3>
                  <p className="text-lg text-blue-600 mb-6">{owner.role}</p>
                  <p className="text-sm text-gray-600 leading-relaxed mb-6">
                    {owner.description}
                  </p>
                  <div className="space-y-3">
                    <div className="flex items-center text-sm text-gray-700">
                      <i className="ri-mail-line text-blue-600 mr-3 text-lg"></i>
                      <a href="mailto:retnodwilestari@gmail.com" className="hover:text-blue-600 transition-colors">
                        retnodwilestari@gmail.com
                      </a>
                    </div>
                    <div className="flex items-center text-sm text-gray-700">
                      <i className="ri-whatsapp-line text-blue-600 mr-3 text-lg"></i>
                      <a href="https://wa.me/62895338139977" target="_blank" rel="noopener noreferrer" className="hover:text-blue-600 transition-colors">
                        0895-3381-3997-7
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-br from-blue-600 to-cyan-600">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
            Bergabunglah dengan Ribuan Pelanggan Puas Kami
          </h2>
          <p className="text-lg text-white/95 mb-10 max-w-2xl mx-auto leading-relaxed">
            Percayakan kebutuhan laundry Anda kepada YEZ Laundry dan rasakan perbedaan layanan profesional kami
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="https://wa.me/62895338139977?text=Halo%20YEZ%20Laundry%2C%20saya%20ingin%20bertanya%20tentang%20layanan%20laundry"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-white text-teal-600 px-8 py-4 rounded-full text-base font-semibold hover:bg-gray-50 transition-all shadow-lg hover:shadow-xl whitespace-nowrap inline-flex items-center"
            >
              <i className="ri-whatsapp-line mr-2 text-xl"></i>
              Hubungi via WhatsApp
            </a>
            <a
              href="tel:+62895338139977"
              className="bg-transparent text-white px-8 py-4 rounded-full text-base font-semibold border-2 border-white hover:bg-white/10 transition-all whitespace-nowrap inline-flex items-center"
            >
              <i className="ri-phone-line mr-2 text-xl"></i>
              Telepon Sekarang
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
